import { status, StatusType } from '../typeStatus'

export const VALIDATE_ACCOUNT = 'VALIDATE_ACCOUN'
export const VALIDATE_ACCOUNT_SUCCESS = 'VALIDATE_ACCOUNT_SUCCESS'
export const VALIDATE_ACCOUNT_ERROR = 'VALIDATE_ACCOUNT_ERROR'
export const VALIDATE_ACCOUNT_RESET = 'VALIDATE_ACCOUNT_RESET'

export interface ValidateType {
  existente: boolean
  malFormato: boolean
}

export interface ValidateAccount {
  type: typeof VALIDATE_ACCOUNT
  payload: ValidateType | null
}

export interface ValidateAccountSuccess {
  type: typeof VALIDATE_ACCOUNT_SUCCESS
  payload: ValidateType
}

export interface ValidateAccountError {
  type: typeof VALIDATE_ACCOUNT_ERROR
  payload: null
}

export interface ValidateAccountReset {
  type: typeof VALIDATE_ACCOUNT_RESET
  payload: null
}

export interface ValidateAccountState {
  status: StatusType
  validationAccount: ValidateType | null
}

export const initialState: ValidateAccountState = {
  status: status.initial,
  validationAccount: null,
}

export type ValidationAccountActions =
  | ValidateAccount
  | ValidateAccountError
  | ValidateAccountReset
  | ValidateAccountSuccess
